import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class EnterWarehouseRegister {
  // 进仓登记列表
  static getEnterWarehouseRegisterList(options) {
    let url = '/zwy/api/storage/receipt/order/page?'
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 导入增值费用
  static postUploadAddServiceExcel(data) {
    const url = `/zwy/api/storage/receipt/order/upload/add/service/fee`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 导入操作费用
  static postUploadOperateFeeExcel(data) {
    const url = `/zwy/api/storage/receipt/order/upload/fee`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 进仓单详情
  static getEnterWarehouseRegisterDetails(id) {
    const url = `/zwy/api/storage/receipt/order/get/${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 编辑进仓登记备注
  static postModEnterWarehouseRemarks(id, data) {
    const url = `/zwy/api/storage/receipt/order/update/remark/${id}`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 保存进仓登记
  static postSaveEnterWarehouseRegister(id, data) {
    const url = `/zwy/api/storage/receipt/order/update/fee/${id}`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 获取进仓单增值服务费用导入模板 */
  static getEnterWarehouseAddServiceTmp() {
    const url = `/zwy/api/storage/receipt/order/download/service/fee/template/file`
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
}

export default EnterWarehouseRegister